// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"1bc8e4c2","797":"645e5ba3","962":"dca82afe"}[chunkId] + ".chunk.js";
};